<!-- <p>{{ alarm | json }}</p> DEBUG -->
<section class="alarm_line" [id]="alarm.uid" [ngClass]="{'not-acknowledged' : (alarm.state === alarmStates.RAISED)}" (mouseenter)="showButton=true" (mouseleave)="showButton=false">
  <div class="seriousness"> <span [ngClass]="'seriousness' + alarm.level"><i class="icon-bell1"></i></span></div>
  <div class="dateState"> <span>{{ alarm.dateTime | date: dateFormat:undefined:language}}</span></div>
  <!--  {{ value_expression | date [ : format [ : timezone [ : locale ] ] ] }}
  Timezone default(=undefined) is the local system timezone of the end-user's machine.  -->
  <div class="tag"> <span>{{ alarm.tag }}</span></div>
  <div class="message"> <span>{{ alarm.message }}</span></div>
  <div class="equipement"> <span>{{ alarm.stationName }}</span></div>
  <div class="state"> <span>{{ alarmStateFrench[alarm.state] }}</span></div>
  <div class="action">
    @if (showButton===false) {
      <span><i class="icon-eye faded"></i></span>
    }
    @if (alarm.state === alarmStates.RAISED && showButton) {
      <button (click)="acknowledgeAlarm(alarm.uid)" [ngClass]="changingStatus ? 'pulse with-icon' : ' with-icon'" [disabled]="changingStatus">
        {{'action.acquit' | translate}} <span class="button-icon-container"><i class="icon-eye"></i></span>
      </button>
    } @else {
      @if (showButton) {
        <button (click)="reactivateAlarm(alarm.uid)" [ngClass]="changingStatus ? 'pulse with-icon' : 'table-action-blue with-icon'" [disabled]="changingStatus">
          {{'action.restore' | translate}} <span class="button-icon-container"><i class="icon-eye-off"></i></span>
        </button>
      }
    }
  </div>
</section>
